export function sameHeight(elements, direction) {

    if(elements.length) {

        if(window.innerWidth > 992) {
            let height = 0;

            for (var k in elements) {
                let element = elements[k];

                if(!element) {
                    continue;
                }

                if (direction == 'min' && height != 0 && height > element.getBoundingClientRect().height) {
                    height = element.getBoundingClientRect().height;
                } else if (direction == 'max' && height < element.getBoundingClientRect().height) {
                    height = element.getBoundingClientRect().height;
                }
            }

            for (var k in elements) {
                let element = elements[k];

                if(!element) {
                    continue;
                }
                element.style.setProperty('height', height + 'px');
            }
        } else {
            for (var k in elements) {

                let element = elements[k];
                if(!element) {
                    continue;
                }
                element.style.removeProperty('height');
            }
        }
    }

}



//////////////////
// WEBPACK FOOTER
// ./js/2020/_sameHeight.js
// module id = 5
// module chunks = 0